import {Component} from 'react';

import './HistoricalData.css';

import { background_2 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import IngestionStatus from './content/HistoricalArchive/IngestionStatus';
import parse from 'csv-parse/lib/sync';
import { get_data_file_url } from '../../utils/data';
import request from '@acri-tools/react-tools/utils/request';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import StatusTable from '../../components/StatusTable/StatusTable';
import IngestionStatistics from './content/IngestionStatistics/IngestionStatistics';
import { get_page_title } from '../../utils/config';
import { Helmet } from 'react-helmet';

interface Props{
}
interface State{
    loading_datasets: boolean

    dataset_data?: Array<any>
    aux_data?: Array<any>
}

export default class HistoricalData extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
            loading_datasets: false
        }
    }

    componentDidMount(){
        this.fetch_dataset_data()
    }

    fetch_dataset_data = async() =>{
        this.setState({ loading_datasets: true });
        try{
            // let res = await request(get_data_file_url(`ingestion_status_del.csv`),{
            let res = await request(get_data_file_url(`ingestion_dataset_detail.csv`),{
            // let res = await request(`${API_URL}/api/user-manager/v1/files/media/ingestion_dataset_detail_v2.csv`,{
                method: 'get'
            })

            // console.log('dfsd', res.data)
            let csv_data = parse(res.data, { delimiter: ';' });
            
            let headers = csv_data.shift();

            let dataset_data:any = [];
            let aux_data:any = [];

            // mission instrument product_type dataset nb_prod nb_file 
            // size(GB) pct_arch pct_sent pct_tape pct_disk source format master_dataset
            for(let d of csv_data){
                let json = {
                    mission: d[0],
                    instrument: d[1],
                    product_type: d[2],
                    dataset: d[3],
                    nb_prod: d[4],
                    nb_file: d[5],
                    size: d[6],
                    archived: d[7],
                    sent: d[8],
                    tape: d[9],
                    disk: d[10]
                }
                if(d[1] === 'AUX'){
                    aux_data.push(json)
                }
                else{
                    dataset_data.push(json);
                }
            }

            this.setState({ dataset_data, aux_data });
        }
        catch(e:any){
            axiosErrorHandler(e, { functionName: `fetch_dataset_data` });
            toast_request_error(e);
        }
        finally{
            this.setState({ loading_datasets:false })
        } 
    }

    render(){
        let tabs = [
            {
                label: <>Ingestion Status</>,
                content: <div className="historical-data-content">
                    <IngestionStatus/>
                </div>
            },
            {
                label: <>Datasets Status</>,
                content: <div className="historical-data-content">
                    {
                        this.state.loading_datasets ? 
                            <div className="centered">
                                <Spinner/>
                            </div>
                        :
                            this.state.dataset_data ? 
                                <StatusTable data={this.state.dataset_data}/>
                            : 
                                <div className="no-data">No Data to show</div>
                    }
                </div>
            },
            {
                label: <>Auxiliary Datasets Status</>,
                content: <div className="historical-data-content">
                    {
                        this.state.loading_datasets ? 
                            <div className="centered">
                                <Spinner/>
                            </div>
                        :
                            this.state.aux_data ? 
                                <StatusTable data={this.state.aux_data}/>
                            : 
                                <div className="no-data">No Data to show</div>
                    }
                </div>
            },
            {
                label: <>Ingestion Statistics</>,
                content: <div className="historical-data-content">
                    <IngestionStatistics/>
                </div>
            },
        ]
        return (
        <Page 
            id="historical-data"
            banner={{
                title: "historical data",
                bannerImage: background_2,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - Historical Data') }</title>
                <meta 
                    name="description" 
                    content="DAMPS historical data details"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <div className="historical-data-legend">
                        {
                            [
                                // { name: 'disk', detail: '2 disk copies in main center' },
                                // { name: 'tape', detail: '2 tape copies in main center' },
                                // { name: 'sent', detail: '1 copy in both centers' },
                                // { name: 'archived', detail: 'Certified copies in main center' },
                                
                                { name: 'disk', detail: '2 copies in Main Center' },
                                { name: 'main-archived', detail: '2 verified copies in Main Center' },
                                { name: 'backuped', detail: '3 copies in both Centers' },
                                { name: 'archived', detail: '2 verified copies in both Centers' },

                                // { name: 'disk', detail: '2 disk copies in main center' },
                                // { name: 'main-archived', detail: '...' },
                                // { name: 'backup-ready', detail: '...' },
                                // { name: 'backup-disk', detail: '...' },
                                // { name: 'archived', detail: '...' },
                            ].map((legend)=>(
                                <div className={`historical-data-legend-item ${legend.name}-data`}>
                                    <i className="fas fa-hdd"/>
                                    <div className="historical-data-legend-info">
                                        <div className="historical-data-legend-name">
                                            { legend.name }
                                        </div>
                                        <div className="historical-data-legend-detail">
                                            { legend.detail }
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    {/* <div className="">
                    </div> */}
                    <Tabs tabs={tabs}/>
                </div>
            </div>
        </Page>
        );
    }

};
